import { useMemo } from "react";
import { Field } from "react-final-form";
import classNames from "classnames";

import Radio from "@components/Form/Radio";
import { composeFormValidators, isRequired } from "@lib/validations";
import SelectSearch from "@components/Form/SelectSearch";

const LeasingSection = ({ isLeasing, apiData }) => {
  const { leasingCompanies } = apiData;

  const leasingOptions = useMemo(
    () =>
      leasingCompanies &&
      leasingCompanies.map((company) => ({
        label: company.companyName,
        value: company.cif,
      })),
    [leasingCompanies]
  );

  return (
    <>
      <div className="mb-6">
        <div className="text-sm font-medium mb-[10px]">
          Autovehiculul este obiectul unui contract de leasing in desfasurare?{" "}
          <span className="text-red-brand">*</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            className={classNames("flex items-center p-[16px] bg-white", {
              "border border-[#99CE88]": !isLeasing,
            })}
          >
            <Field
              name="isLeasing"
              value="false"
              component={Radio}
              label="Nu"
              type="radio"
              labelClass="font-normal text-[14px]"
              className={classNames("cursor-pointer w-full mb-0", {
                "pointer-events-none": !isLeasing,
              })}
            />
          </div>

          <div
            className={classNames("flex items-center p-[16px] bg-white", {
              "border border-[#99CE88]": isLeasing,
            })}
          >
            <Field
              name="isLeasing"
              value="true"
              component={Radio}
              label="Da"
              type="radio"
              labelClass="font-normal text-[14px]"
              className={classNames("cursor-pointer w-full mb-0", {
                "pointer-events-none": isLeasing,
              })}
            />
          </div>
        </div>
      </div>

      {isLeasing && apiData.leasingCompanies?.length && (
        <div className="bg-white p-[16px]">
          <Field
            name="leasingCompanyCif"
            component={SelectSearch}
            label="Nume companie leasing"
            required
            labelClass="text-sm font-medium"
            controlClassName="max-w-fulli"
            validate={composeFormValidators(isRequired())}
            placeholder="alege..."
            parse={(option) => option?.value ?? ""}
            format={(value) =>
              leasingOptions.find(
                (option) => String(option.value) === String(value)
              )
            }
            options={leasingOptions || []}
          />
        </div>
      )}
    </>
  );
};

export default LeasingSection;
